import Register from "@/pages/Registration/Layout.vue";
import CambiarPassword from "@/pages/Dashboard/CambiarPassword.vue";


export default [
    {
        path: '/registro/step-:step',
        name: 'register',
        component: Register,
        meta: { hideHeader: true, hideFooter: true }
    },
    {
        path: '/login',
        name: 'login',
        component: Register,
        meta: { hideHeader: true, hideFooter: true }
    },
    {
        // Entra por el mismo marco que el login (Layout.vue): misma barra, mismo
        // pie y mismos tokens. El formulario en sí es pages/Login/Recuperar.vue,
        // que Layout monta cuando la ruta es esta.
        path: '/auth/recuperar',
        name: 'recuperar',
        component: Register,
        meta: { hideHeader: true, hideFooter: true }
    },
    {
        // El segundo tramo del flujo de recuperación, el que se abre desde el
        // correo. Mismo marco que el login y que /auth/recuperar: el formulario
        // es pages/Login/CambiarClave.vue, que monta Layout.
        path: '/cambiar/clave/:token',
        name: 'Cambiar clave',
        component: Register,
        meta: { hideHeader: true, hideFooter: true }
    },
    {
        path: '/cambiar-password',
        name: 'Cambiar Password',
        component: CambiarPassword,
        meta: {
            requiresAuth: true,
            showDashboard: true
        }
    },
];